// **************************************************
// Custom form submit event & response output element
// **************************************************

function jobPageOutput() {

  // Get elements
  const wpcf7Elm = document.querySelector( '.wpcf7' )
  const formResponseElement = document.querySelector('.wpcf7-response-output')
  const siteOverlayElement = document.querySelector('.site__overlay')

  if (wpcf7Elm) {

    // On wpcf7 submit event
    wpcf7Elm.addEventListener( 'wpcf7submit', function(e) {
      // Enable overlay
      siteOverlayElement.style.display = 'block' 
      // Reset opacity to 1
      TweenLite.to('.wpcf7-response-output', 0.5, {opacity:1})
      // After 3 sec
      setTimeout(() => {
        // Fade out opacity to 0
        TweenLite.to('.wpcf7-response-output', 0.5, {
          opacity:0,
          onComplete:function() { 
            // Reset elements styles
            formResponseElement.style.display = 'none'
            siteOverlayElement.style.display = 'none' 
          }
        })
      }, 3500)
      
    }, false )
  }

  

}

export default jobPageOutput